import { render, staticRenderFns } from "./account-menu.vue?vue&type=template&id=a1fab2f8"
import script from "./account-menu.vue?vue&type=script&lang=js"
export * from "./account-menu.vue?vue&type=script&lang=js"
import style0 from "./account-menu.vue?vue&type=style&index=0&id=a1fab2f8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports